

import { UseFormReturn, ControllerRenderProps } from 'react-hook-form';
import type { BlogPostFormData } from '@/services/blog/types';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';

interface ContentFieldsProps {
  form: UseFormReturn<BlogPostFormData>;
}

export const ContentFields: React.FC<ContentFieldsProps> = ({ form }) => {
  return (
    <>
      <FormField
        control={form.control}
        name="summary"
        render={({ field }: { field: ControllerRenderProps<BlogPostFormData, 'summary'> }) => (
          <FormItem>
            <FormLabel>Summary</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Brief summary of the blog post" 
                className="min-h-[80px]"
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="content"
        render={({ field }: { field: ControllerRenderProps<BlogPostFormData, 'content'> }) => (
          <FormItem>
            <FormLabel>Content</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Write your blog post content here..." 
                className="min-h-[300px]"
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
